<template>
    <div class="form-control w-full relative">
        <client-only>
            <MiscLoadingBar ref="loadingBar" />
        </client-only>
        <label for="sorter" class="label sr-only">
            <span class="label-text">{{ $t('product.listing.sorter.sortBy') }}</span>
        </label>

        <span class="absolute inset-y-0 left-0 flex items-center pl-3 pb-px text-primary pointer-events-none z-10">
            <MiscIcon name="arrow-up-down" class="brand-page-color-active:text-brand-page-color" />
        </span>
        <select
            id="sorter"
            v-model="model"
            class="select w-full pl-11 bg-transparent brand-page-color-active:text-brand-page-color brand-page-color-active:bg-brand-page-bg brand-page-color-active:border-brand-page-color"
        >
            <option
                v-for="item in sortingOptions"
                :key="item.value"
                :value="item.value"
                v-text="item.label"
            />
        </select>
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
import { getTranslatedProperty } from '@shopware/helpers'

export interface SelectOption {
    value: string | number;
    label: string;
}

const props = defineProps<{
    limit: number
    currentSorting?: string
    availableSortings?: Schemas['ProductListingResult']['availableSortings'] | { key: string; label: string }[] | undefined
}>()

const emit = defineEmits<{
    (e: 'update:sorting', sorting: string): void
}>()

const model = ref(props.currentSorting)
watch(model, (newValue) => {
    if (newValue !== props.currentSorting) {
        emit('update:sorting', newValue as string)
    }
})

watch(() => props.currentSorting, (newValue) => {
    model.value = newValue
})

const getSortingLabel = (sorting: Schemas['ProductListingResult']['availableSortings'][number] | { key: string; label: string }): string => {
    return getTranslatedProperty(sorting, 'label') || sorting.label || sorting.key || ''
}

const sortingOptions = computed<SelectOption[]>(() => {
    if (!props.availableSortings) {
        return []
    }

    return props.availableSortings.map(sorting => ({
        value: sorting.key,
        label: getSortingLabel(sorting)
    }))
})
</script>
